var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagramIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Fill 23") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28,29 L4,29 C3.448,29 3,28.552 3,28 L3,13 L7,13 C6.479,13.75 6.303,15.149 6.303,16.037 C6.303,21.392 10.67,25.749 16.037,25.749 C21.405,25.749 25.772,21.392 25.772,16.037 C25.772,15.149 25.646,13.771 25,13 L29,13 L29,28 C29,28.552 28.552,29 28,29 M16.037,9.898 C19.436,9.898 22.191,12.647 22.191,16.037 C22.191,19.428 19.436,22.177 16.037,22.177 C12.639,22.177 9.884,19.428 9.884,16.037 C9.884,12.647 12.639,9.898 16.037,9.898 M24,4 L27,4 C27.552,4 28,4.448 28,5 L28,8 C28,8.552 27.552,9 27,9 L24,9 C23.448,9 23,8.552 23,8 L23,5 C23,4.448 23.448,4 24,4 M28.196,0 L3.804,0 C1.703,0 0,1.699 0,3.795 L0,28.205 C0,30.301 1.703,32 3.804,32 L28.196,32 C30.297,32 32,30.301 32,28.205 L32,3.795 C32,1.699 30.297,0 28.196,0",
    id: "Fill-23",
    fill: "#FFFFFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIcon);
export default __webpack_public_path__ + "static/media/instagram_icon.73771db9ab5c563de49250626d6ec217.svg";
export { ForwardRef as ReactComponent };